import { FunctionComponent } from "react";
import styles from "./description.module.scss";

const Description: FunctionComponent<{
  children: any;
  className?: string;
}> = ({ children, className = "" }) => {
  return <p className={`${styles.description} ${className}`}>{children}</p>;
};

export default Description;
